module.exports = __webpack_public_path__ + "static/media/banner-right-asset.3d81384c.png";